import HttpRequest from './HttpRequest';

export default class SizesService extends HttpRequest {
  static endpoint = 'sizes';

  static async getByBrand(brandId) {
    this.endpoint = 'sizes';
    const response = await this.get(`by-brand/${brandId}`);
    return response;
  }

  static async getById(id) {
    this.endpoint = 'sizes';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'sizes';
    const response = await this.post(data);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'sizes';
    const response = await this.put(id, data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'sizes';
    const response = await this.delete(id);
    return response;
  }  
}
